import { AlertTriangle } from 'lucide-react'

interface AttentionBannerProps {
  items: string[]
}

export function AttentionBanner({ items }: AttentionBannerProps) {
  if (items.length === 0) return null

  return (
    <div className="mb-8 bg-ml-error/5 border-l-4 border-ml-error/60 p-5 rounded-r-xl flex items-center justify-between gap-4">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-ml-error shrink-0 mt-0.5" />
        <div className="space-y-0.5">
          <p className="text-sm font-semibold text-ml-error">Alertas que requieren atención</p>
          {items.map((item) => (
            <p key={item} className="text-sm text-ml-on-surface-variant">{item}</p>
          ))}
        </div>
      </div>
    </div>
  )
}
